import axiosInstance from '@/services/axiosInstance'

async function importListaBlancaEmailsGrupo (file, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const formData = new FormData()
    formData.append('file', file.raw)

    const req = {
      url: '/api/importaciones/importarlistablancaemailsgrupo',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data'
      },
      data: formData,
      params,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { importListaBlancaEmailsGrupo }
